<template>
  <div class="house-type-manage" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>户型名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入户型名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newHouseType()">新增户型</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editHouseType(data)">编辑</a-button>
          <a-button type="link" @click="deleteHouseType(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
  import HouseTypeService from '@/io/house_type.js';

  export default {
    name: 'HouseTypeManage',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            area: null,
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '户型名称',
              dataIndex: 'name'
            },
            {
              title: '建筑面积',
              dataIndex: 'build_area'
            },
            {
              title: '套内面积',
              dataIndex: 'use_area'
            },
            {
              title: '公摊面积',
              dataIndex: 'public_area'
            },
            {
              title: '赠送面积',
              dataIndex: 'gift_area'
            },
            {
              title: '户型信息',
              dataIndex: 'infoText'
            },
            {
              title: '房间数量',
              dataIndex: 'housing_count'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            this.searchTable();
          }
        },
        immediate: true
      }
    },
    activated() {
      if (this.communityId) {
        this.initData();
      }
    },
    methods: {
      newHouseType() {
        this.table.page.current = 1;
        this.toPage({
          name: 'NewHouseType'
        });
      },
      editHouseType(data) {
        this.toPage({
          name: 'EditHouseType',
          params: {
            id: data.id
          }
        });
      },
      toPage(params) {
        if (this.communityId) {
          params = {
            ...params,
            query: {
              community_id: this.communityId
            }
          }
        }
        this.$router.push(params);
      },
      deleteHouseType(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此户型？',
          onOk() {
            HouseTypeService.del(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        HouseTypeService.listPage(
          this.communityId,
          this.table.search.name,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.infoText = `${val.room}室${val.hall}厅${val.toilet}卫`;
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>